import React from 'react';
import Header from './components/Header';
import Social from './components/Social';
import About from './components/About';
import Accordions from './components/Accordions';
import TypeWriter from './components/TypeWriter';
import ImageSwiper from './components/ImageSwiper';
import Clients from './components/Clients';
import Share from './components/Share';
import Footer from './components/Footer';
import background from './images/bg.jpg';
import background1 from './images/bg1.jpg';

import BottomSwiper from './components/BottomSwiper';

function App() {

  var domainUrl = 'https://pazpilates.netlify.app/'
  var businessName = 'Paz Pilates';
  var businessDescription = 'פילאטיס בוטיק בחולון'
  var phoneNumber = '+972523957524'
  var email = 'pazkerenk1976@gmail.com'
  var facebookUrl = 'https://www.facebook.com/profile.php?id=100000473793701'
  var instagram = 'keren_paz1976'
  var whatsapp = '+972523957524'
  var wazeUrl = 'https://www.waze.com/he/live-map/directions/%D7%93%D7%91%D7%95%D7%A8%D7%94-%D7%94%D7%A0%D7%91%D7%99%D7%90%D7%94-5-%D7%97%D7%95%D7%9C%D7%95%D7%9F?to=place.w.22806848.228068481.96905'
  var days = "א' -  ה'"
  var hours = '10:30 - 20:30'
  //קצת עליי
  //טיפולים בקליניקה
  //לקוחות ממליצים
  //icon
  //שם ותיאור


  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  const divStyle1 = {
    backgroundImage: `url(${background1})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div className="bg-gray-50 w-full">
      <div className=" md:w-4/5 lg:max-w-[1152px] mx-auto shadow-2xl">
        <div className="object-cover">
          <div style={divStyle}>
            <Header
              businessName={businessName}
              businessDescription={businessDescription} />

            <Social
              businessName={businessName}
              businessDescription={businessDescription}
              phoneNumber={phoneNumber}
              email={email}
              facebookUrl={facebookUrl}
              instagram={instagram}
              whatsapp={whatsapp}
              wazeUrl={wazeUrl}
              domainUrl={domainUrl}
            />
            <About />

            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
            <TypeWriter
              businessName={businessName}
              businessDescription={businessDescription}
            />

          </div>
          <div style={divStyle}>
            <ImageSwiper />

            <BottomSwiper />

            <Clients
              whatsapp={whatsapp} />

            <Share domainUrl={domainUrl} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
